export enum FieldNames {
  city = "city",
  country = "country",
  region = "region",
  postalCode = "postal_code",
  street1 = "street1",
  street2 = "street2",
  phone = "phone",
}
